import { ALLIANZ_VARS } from '../config'

export function setDRPForNumberCotizador() {
  let numeroRingpoolCambiar = true
  let numeroRingpoolInterferir = true
  // Observador de mutaciones para esperar a que #dmvText esté disponible
  const observer = new MutationObserver((mutations, observer) => {
    if (
      document.querySelector('.contact-us.html-drp-phone') &&
      typeof DFI != 'undefined' &&
      typeof DFI.buildMaskString != 'undefined' &&
      typeof DFI.DFI_configuration != 'undefined'
    ) {
      document
        .querySelector('.contact-us.html-drp-phone')
        .classList.add('drp-phone')

      if (!document.querySelector('.ringpool-wrap')) {
        const elementToDelete = document.querySelector(
          '.head .nx-link .contact-us.html-drp-phone'
        )
        elementToDelete.setAttribute('style', 'display:none')

        const ringPoolWrap = document.createElement('div')
        ringPoolWrap.classList.add('ringpool-wrap')
        ringPoolWrap.style.display = 'none'

        setTimeout(() => {
          ringPoolWrap.style.display = 'flex'
        }, 1000)

        const iconTel = document.createElement('img')
        iconTel.src = ALLIANZ_VARS.paths.iconTel
        iconTel.classList.add('ringpool-icon')

        const ringpool = document.createElement('a')
        ringpool.classList.add(
          'drp-phone-new',
          'wal-drp-phone',
          'ringpool-number',
          'drp-phone'
        )

        let ringpoolWithMask = window.DFI.buildMaskString(
          window.DFI.telefonoRingPoolActivo ?? '919498177',
          window.DFI.DFI_configuration.services.serviceList.ringPool.phoneMask
        )

        ringpool.setAttribute('href', `tel:${ringpoolWithMask}`)
        ringpool.innerText = ringpoolWithMask

        ringPoolWrap.appendChild(iconTel)
        ringPoolWrap.appendChild(ringpool)

        const $elementToInsertRingpool =
          document.querySelector('.head .nx-link')
        $elementToInsertRingpool.appendChild(ringPoolWrap)
      }
    }

    if (
      document.querySelectorAll(
        '.footer-extras.mobile-options > .footer-option.nx-button--primary .drp-phone'
      ).length > 0 &&
      numeroRingpoolCambiar
    ) {
      const btnParrillaDRP = document.querySelectorAll(
        '.footer-extras.mobile-options > .footer-option.nx-button--primary .drp-phone'
      )

      if (
        typeof DFI != 'undefined' &&
        typeof DFI.buildMaskString != 'undefined' &&
        typeof DFI.DFI_configuration != 'undefined' &&
        btnParrillaDRP[0].text != window.DFI.telefonoRingPoolActivo
      ) {
        btnParrillaDRP.forEach((selector) => {
          let ringpoolWithMask = window.DFI.buildMaskString(
            window.DFI.telefonoRingPoolActivo ?? '919498177',
            window.DFI.DFI_configuration.services.serviceList.ringPool.phoneMask
          )

          selector.innerText = ringpoolWithMask
        })
      }

      numeroRingpoolCambiar = false
    }

    // boton en parrilla no se interfiere numero de href, solo visible
    // si el boton tiene html-drp-phone que se le añada clase wal-drp-phone para interferir
    if (
      document.querySelectorAll(
        '.footer-extras.mobile-options > .footer-option.nx-button--primary .html-drp-phone'
      ).length > 0 &&
      numeroRingpoolInterferir
    ) {
      const btnParrillaDRPClass = document.querySelectorAll(
        '.footer-extras.mobile-options > .footer-option.nx-button--primary .html-drp-phone'
      )

      btnParrillaDRPClass.forEach((selector) => {
        if (!selector.classList.contains('wal-drp-phone')) {
          selector.classList.add('wal-drp-phone')
        }
      })

      numeroRingpoolInterferir = false
    }
  })

  // Configurar el observador para observar cambios en el nodo body y sus descendientes
  observer.observe(document.body, { childList: true, subtree: true })
}
